import { render } from "./List2.vue?vue&type=template&id=5c41d136&scoped=true"
import script from "./List2.vue?vue&type=script&lang=js"
export * from "./List2.vue?vue&type=script&lang=js"

import "./List2.vue?vue&type=style&index=0&id=5c41d136&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c41d136"]])

export default __exports__